<div [formGroup]="form()" class="flex flex-col gap-3 custom-form-readonly">
  <div class="flex flex-col">
    <div class="flex items-center gap-2">
      <span class="text-lg">{{ 'pages.campaignForm.sections.basics.teamsLabel' | translate }}</span>
      <!-- Tooltip goes on this wrapping span, not the toggle itself - a disabled control doesn't
           reliably fire the hover events MatTooltip needs. -->
      <span
        matTooltipPosition="above"
        [matTooltip]="'pages.campaignForm.sections.basics.teamsAdminOnlyTooltip' | translate"
        [matTooltipDisabled]="loading() || hasSelectableOptions()"
      >
        <mat-slide-toggle
          [checked]="visibilityEnabled()"
          [hideIcon]="true"
          [disabled]="loading() || !hasSelectableOptions()"
          (change)="onVisibilityToggleChange($event)"
        />
      </span>
    </div>
    <div class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.basics.teamsDescription' | translate }}
    </div>
  </div>

  @if (form().controls.whitelist.value?.length !== 0 && loading()) {
    <div class="w-full mat-form-field-with-icon rounded-full border border-shikenso-purple-base-12 pl-2 pr-4 py-[7px]">
      <div class="flex items-center justify-between">
        <div class="scrollbar-hidden-x flex items-center gap-2 max-w-[592px]">
          @for (index of skeletonPillIndexes(); track index) {
            <ngx-skeleton-loader class="h-8" [theme]="{ height: '32px', width: '120px', 'border-radius': '100vw' }" />
          }
        </div>
        <app-icon src="icons/chevron-down.svg" alt="chevron down" [size]="20" />
      </div>
    </div>
  } @else {
    <mat-form-field class="w-full mat-form-field-with-icon">
      <mat-select
        panelClass="custom-select-panel"
        multiple
        [formControl]="selectedEntryIdsControl"
        [hideSingleSelectionIndicator]="true"
        [placeholder]="'pages.campaignForm.sections.basics.teamsPlaceholder' | translate"
      >
        <mat-select-trigger>
          <div class="scrollbar-hidden-x flex items-center gap-2 max-w-[592px]">
            @if (selectedEntries().length === 0) {
              <div class="flex items-center">
                <span class="text-sm text-shikenso-purple-base-60">
                  {{ 'pages.campaignForm.sections.basics.teamsPlaceholder' | translate }}
                </span>
              </div>
            } @else {
              @for (entry of selectedEntries(); track entry.kind + ':' + entry.id) {
                <div class="flex items-center gap-1 rounded-full bg-shikenso-gray-base pl-1 pr-2 py-1 h-8">
                  <app-icon-badge
                    backgroundColor="var(--shikenso-base-white)"
                    fallbackBackgroundColor="var(--shikenso-base-white)"
                    [content]="entry.iconId ?? null"
                    [fallbackText]="entry.name"
                    [size]="24"
                    [iconSize]="24"
                    [fontSize]="12"
                    [borderRadius]="100"
                  />
                  <span class="text-xs font-bold">{{ entry.name }}</span>

                  @if (!isCurrentUserEntry(entry)) {
                    <button mat-icon-button type="button" (click)="onRemoveEntry(entry, $event)">
                      <app-icon src="icons/x-mark.svg" alt="remove" [size]="16" />
                    </button>
                  }
                </div>
              }
            }
          </div>
        </mat-select-trigger>

        <mat-option>
          <ngx-mat-select-search
            [formControl]="entrySearchControl"
            [placeholderLabel]="'pages.campaignForm.sections.basics.teamsSearch' | translate"
            [noEntriesFoundLabel]="'pages.campaignForm.sections.basics.teamsNoUsersFound' | translate"
          >
            <app-icon ngxMatSelectSearchClear src="icons/close.svg" alt="close" [size]="16" />
          </ngx-mat-select-search>
        </mat-option>

        @if (loading()) {
          @for (index of optionSkeletonIndexes; track index) {
            <mat-option>
              <div class="flex items-center gap-2">
                <ngx-skeleton-loader
                  class="h-6"
                  [theme]="{ height: '24px', width: '24px', 'border-radius': '100vw' }"
                />
                <ngx-skeleton-loader class="h-5" [theme]="{ height: '20px', width: '180px', 'border-radius': '4px' }" />
              </div>
            </mat-option>
          }
        } @else {
          @for (entry of displayedEntries(); track entry.kind + ':' + entry.id) {
            <mat-option [value]="entryId(entry)" [disabled]="isCurrentUserEntry(entry) && visibilityEnabled()">
              <div class="flex items-center gap-2">
                <app-icon-badge
                  [content]="entry.iconId ?? null"
                  [fallbackText]="entry.name"
                  [size]="24"
                  [iconSize]="24"
                  [fontSize]="12"
                  [borderRadius]="100"
                />
                <span class="text-sm">{{ entry.name }}</span>
              </div>
            </mat-option>
          }
        }
      </mat-select>
    </mat-form-field>
  }
</div>
